import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Password } from "../controls";
import { usePersistStore, useStore } from "../store";
import { UserService } from "../services";

interface InputProps {
  show: boolean;
  onHide: () => void;
}

const DeleteAccountPopup: React.FC<InputProps> = ({ show, onHide }) => {
  const { setIsLoading, setSuccessMessage } = useStore((s: any) => s);
  const { logout, token } = usePersistStore((s: any) => s);
  const [currentPassword, setCurrentPassword] = useState<string>("");
  const [validationMessage, setValidationMessage] = useState<string>("");

  const handleDelete = async (e: any) => {
    e?.preventDefault();
    if (!currentPassword)
      return setValidationMessage("Please provide your current password.");

    setIsLoading(true);
    let result = await UserService.deleteMyAccount(token, {
      currentPassword,
    });
    if (result?.error) {
      setIsLoading(false);
      setValidationMessage(result?.error);
      return;
    }

    logout();
    setValidationMessage("");
    setSuccessMessage(
      "Account deleted successfully!. You'll be redirected to home page."
    );
    cleanUpAndClose();
    setTimeout(() => {
      window.location.href = "/";
    }, 2000);
  };

  const cleanUpAndClose = () => {
    setCurrentPassword("");
    setValidationMessage("");
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={cleanUpAndClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="confirmModal deleteAccountModal"
    >
      <Modal.Body>
        <div className="confirmModal__icon confirmModal__icon--danger">
          <i className="bi bi-exclamation-triangle-fill" aria-hidden="true" />
        </div>
        <h2 className="confirmModal__title">Delete your account?</h2>
        <p className="confirmModal__subtitle">
          This will permanently remove your profile, listings, bids, and
          purchase history. This action can't be undone.
        </p>

        <div className="confirmModal__alert confirmModal__alert--danger">
          <i className="bi bi-shield-exclamation" aria-hidden="true" />
          <span>
            Confirm with your current password to continue. We'll sign you
            out and redirect you to the homepage.
          </span>
        </div>

        <form
          className="deleteAccountModal__form"
          onSubmit={handleDelete}
          noValidate
        >
          <Password
            label="Current password"
            placeholder="Enter your current password"
            value={currentPassword}
            onChange={(e: any) => {
              setCurrentPassword(e?.target?.value);
              if (validationMessage) setValidationMessage("");
            }}
            error={validationMessage || undefined}
            autoComplete="current-password"
          />
        </form>

        <div className="confirmModal__footer">
          <Button
            className="closeBtn"
            variant="secondary"
            onClick={cleanUpAndClose}
          >
            Cancel
          </Button>
          <button
            type="button"
            className="confirmModal__danger"
            onClick={handleDelete}
            disabled={!currentPassword}
          >
            Delete my account
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteAccountPopup;
